import { render, staticRenderFns } from "./NoteForm.vue?vue&type=template&id=1d410ef0&scoped=true&"
import script from "./NoteForm.vue?vue&type=script&lang=js&"
export * from "./NoteForm.vue?vue&type=script&lang=js&"
import style0 from "./NoteForm.vue?vue&type=style&index=0&id=1d410ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d410ef0",
  null
  
)

export default component.exports